import gql from 'graphql-tag'

export const SaveProductSelectionMutation = gql`
  mutation updateProductSelection($productOffer: ProductOfferInput!) {
    updateProductSelection(productOffer: $productOffer) {
      id
      applicationId
      productCode
      loanNumber
      amount
      term
      interestRate
      numberOfPayments
      dueDate
      modifiedAt
      stepDownAmt
      applicationStatus
      sasResult
    }
  }
`

export const ExecuteSasValidationsAnalysis = gql`
  mutation executeSasValidationsAnalysis(
    $sasRequest: SasValidationsAnalysisInput!
  ) {
    executeSasValidationsAnalysis(sasRequest: $sasRequest) {
      evaluationResult
    }
  }
`
